import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/outline-style}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: false }, "none", "auto", "dotted", "dashed", "solid", "double", "groove", "ridge", "inset", "outset");
//# sourceMappingURL=outline-style.js.map